import { World } from '@brochington/ecstatic';
import { Components } from 'editor/components';
import MapboxMap from 'editor/components/map/MapboxMap';
import { MapboxTools } from 'editor/components/map/MapboxTool';
import { MapEventType } from 'mapbox-gl';
import placePunchEvents from './placePunchEvents';
import pointerEvents from './pointerEvents';
import postRFIEvents from './postRFIEvents';

export interface MapboxEventArgs<E> {
  evt: E;
  world: World<Components>;
  map: MapboxMap;
}

export type MapboxToolEvents = {
  [K in keyof MapEventType]?: (args: MapboxEventArgs<MapEventType[K]>) => void;
};

export interface MapboxEventHandlers {
  [MapboxTools.Pointer]: MapboxToolEvents;
  [MapboxTools.PostRFI]: MapboxToolEvents;
  [MapboxTools.PlacePunch]: MapboxToolEvents;
}

const mapboxEventHandlers: MapboxEventHandlers = {
  [MapboxTools.Pointer]: pointerEvents,
  [MapboxTools.PostRFI]: postRFIEvents,
  [MapboxTools.PlacePunch]: placePunchEvents,
};

export default mapboxEventHandlers;
